import React from 'react'
import { owner } from '../../core/controllers/Owner';

export default class OwnerExpectedIncomeCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            income: 0
        }
    }

    componentDidMount() {
        var self = this;
        owner.getOwnerExpectedIncome(function(response){
            if (response.data != null) {
                self.setState({
                    income: response.data.income
                });
            }
        });
    }

    render(){
        const income = this.state.income;

        return (
            <div class="col-md-3 col-sm-6 col-xs-12">
                <div class="info-box">
                    <span class="info-box-icon orange-icon-circle"><i class="icon-piggy-bank"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Income</span>
                        <br/>
                        <span class="info-box-subtext">Payouts received this month</span>
                        <span class="info-box-number orange-info-number">${income}</span>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Owners/OwnerExpectedIncomeCard.jsx